<script setup lang="ts">
// ================================
// IMPORTS
// ================================
import { useI18n } from "vue-i18n"
import type { PvEtudeEcoInjectionPriceForm } from "@modules/pv/types/pv-etude-eco-form.types"

// ================================
// INTERNATIONALIZATION
// ================================
const { t } = useI18n({
    messages: {
        fr: {
            sectionTitle: "Prix de rachat de l’électricité",
            placeholder: "----",
            ndj: "Novembre Décembre Janvier",
            fma: "Février Mars Avril",
            mjj: "Mai Juin Juillet",
            aso: "Août Septembre Octobre",
        },
    },
})

// ================================
// PROPS & EMITS
// ================================
withDefaults(
    defineProps<{
        /** Erreurs vee-validate (clés ndj, fma, mjj, aso). */
        fieldErrors?: Record<string, string | undefined>
    }>(),
    {
        fieldErrors: () => ({}),
    }
)

const model = defineModel<PvEtudeEcoInjectionPriceForm>({ required: true })
</script>

<template>
    <div class="pv-etude-eco-form-price flex flex-col gap-4">
        <h3 class="text-base font-semibold text-primary-900">
            {{ t("sectionTitle") }}
        </h3>
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 items-end">
            <BaseInputWrapper
                input-id="pv-eco-ndj"
                :label="t('ndj')"
                suffix="cts €/kWh"
                :error="fieldErrors?.ndj"
            >
                <BaseInputNumber
                    id="pv-eco-ndj"
                    v-model="model.ndj"
                    :min-fraction-digits="0"
                    :max-fraction-digits="4"
                    :step="0.01"
                    :placeholder="t('placeholder')"
                    class="w-full"
                    :invalid="Boolean(fieldErrors?.ndj)"
                />
            </BaseInputWrapper>
            <BaseInputWrapper
                input-id="pv-eco-fma"
                :label="t('fma')"
                suffix="cts €/kWh"
                :error="fieldErrors?.fma"
            >
                <BaseInputNumber
                    id="pv-eco-fma"
                    v-model="model.fma"
                    :min-fraction-digits="0"
                    :max-fraction-digits="4"
                    :step="0.01"
                    :placeholder="t('placeholder')"
                    class="w-full"
                    :invalid="Boolean(fieldErrors?.fma)"
                />
            </BaseInputWrapper>
            <BaseInputWrapper
                input-id="pv-eco-mjj"
                :label="t('mjj')"
                suffix="cts €/kWh"
                :error="fieldErrors?.mjj"
            >
                <BaseInputNumber
                    id="pv-eco-mjj"
                    v-model="model.mjj"
                    :min-fraction-digits="0"
                    :max-fraction-digits="4"
                    :step="0.01"
                    :placeholder="t('placeholder')"
                    class="w-full"
                    :invalid="Boolean(fieldErrors?.mjj)"
                />
            </BaseInputWrapper>
            <BaseInputWrapper
                input-id="pv-eco-aso"
                :label="t('aso')"
                suffix="cts €/kWh"
                :error="fieldErrors?.aso"
            >
                <BaseInputNumber
                    id="pv-eco-aso"
                    v-model="model.aso"
                    :min-fraction-digits="0"
                    :max-fraction-digits="4"
                    :step="0.01"
                    :placeholder="t('placeholder')"
                    class="w-full"
                    :invalid="Boolean(fieldErrors?.aso)"
                />
            </BaseInputWrapper>
        </div>
    </div>
</template>
